import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	removeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteErrorHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	iconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	retryAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	removeButtonLabel: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.remove-button-label',
		defaultMessage: 'Remove linked Loom',
		description:
			'The label attribute of a button used to remove a linked Loom video on a Jira issue',
	},
	deleteErrorHeading: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.delete-error-heading',
		defaultMessage: 'Loom video not removed',
		description:
			'Inline message heading shown when loom link deletion failed and user clicks on the error icon.',
	},
	errorBody: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.error-body',
		defaultMessage: 'Wait a few moments, then give it another try.',
		description:
			'Inline message body shown when loom link creation failed and user clicks on the error icon.',
	},
	iconLabel: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.icon-label',
		defaultMessage: 'warning',
		description: 'Icon label for the Inline message heading.',
	},
	retryAction: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.retry-action',
		defaultMessage: 'Try again',
		description: 'Action label to retry when a creation or deletion error occurs.',
	},
	cancelAction: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.cancel-action',
		defaultMessage: 'Cancel',
		description: 'Action label to cancel when a creation or deletion error occurs.',
	},
});
